module.exports = __webpack_public_path__ + "76a162e1eeeb6d32544af9e8b4691722.png";